import React from 'react';
import {Box, Link, Tooltip, Typography} from "@material-ui/core";

/**
 * Muestra un código de equivalencia.
 *
 * Si el código existe en el catálogo (viene con `idarticulo`) se muestra como link.
 * Si no existe, se muestra como texto plano: es un código de otra marca que Berner
 * no comercializa.
 *
 * El componente no abre ningún diálogo por su cuenta: avisa al padre con `onNavigate`
 * y el padre decide qué mostrar. Así se evita que este helper dependa del detalle del
 * artículo (que a su vez muestra equivalencias, lo que generaría un ciclo de imports).
 */
export const CodigoEquivalente = ({codigo, onNavigate}) => {
    const esClickeable = !!codigo.idarticulo && !!onNavigate;

    if (!esClickeable)
        return (
            <Tooltip title={codigo.idarticulo ? (codigo.detalle || '') : 'No está en el stock'}>
                <Typography variant={"body2"} component={"span"} color={"textPrimary"}>
                    {codigo.codigo}
                </Typography>
            </Tooltip>
        );

    const onClick = event => {
        event.preventDefault();
        event.stopPropagation();
        onNavigate(codigo.idarticulo);
    };

    return (
        <Tooltip title={codigo.detalle || 'Ver artículo'}>
            <Link
                href={'#'}
                onClick={onClick}
                variant={"body2"}
                color={"primary"}
                style={{fontWeight: 500}}
            >
                {codigo.codigo}
            </Link>
        </Tooltip>
    );
};

/**
 * Lista los códigos de una marca dentro de un grupo (una marca puede tener varios).
 *
 * Va con padding propio porque ReactGrid renderiza las celdas "custom" con padding 0
 * (están pensadas para iconos centrados). Los 16px coinciden con el padding por
 * defecto de MUI, así que las columnas quedan alineadas con sus encabezados.
 */
export const CodigosEquivalentes = ({codigos, onNavigate}) => {
    const contenido = (!codigos || codigos.length === 0)
        ? <Typography variant={"body2"} component={"span"} color={"textSecondary"}>-</Typography>
        : codigos.map((codigo, index) => (
            <CodigoEquivalente
                key={`${codigo.marca}-${codigo.codigo}-${index}`}
                codigo={codigo}
                onNavigate={onNavigate}
            />
        ));

    return (
        <Box display={"flex"} flexDirection={"column"} px={2} py={1}>
            {contenido}
        </Box>
    );
};
